import { fetchData } from 'Utils/fetch-data';
import type {
  FetchResponseI,
  CreateOpportunityRequestPayloadI,
  PatchOpportunityRequestPayloadI,
  OpportunityRequestListItemI,
  OpportunityRequestsQueryI,
  OpportunityRequestI,
} from 'types';

export interface OpportunityRequestCreatedI {
  id: string;
  lessonId: string;
  status: 'pending';
  createdAt: string;
}

export interface OpportunityRequestPatchedI {
  id: string;
  status: 'approved' | 'rejected';
  comment: string | null;
  reviewedAt: string;
}

class EvaluationOpportunityRequestsApi {
  private readonly endpoint = '/evaluation-opportunity-requests';

  async create(
    payload: CreateOpportunityRequestPayloadI
  ): Promise<FetchResponseI<OpportunityRequestCreatedI>> {
    return fetchData<OpportunityRequestCreatedI>(this.endpoint, {
      method: 'POST',
      data: payload,
    });
  }

  async patch(
    id: string,
    payload: PatchOpportunityRequestPayloadI
  ): Promise<FetchResponseI<OpportunityRequestPatchedI>> {
    return fetchData<OpportunityRequestPatchedI>(`${this.endpoint}/${id}`, {
      method: 'PATCH',
      data: payload,
    });
  }

  async listByCourse(
    courseId: string,
    query: OpportunityRequestsQueryI = {}
  ): Promise<FetchResponseI<OpportunityRequestListItemI[]>> {
    return fetchData<OpportunityRequestListItemI[]>(
      `/courses/${courseId}/evaluation-opportunity-requests`,
      {
        method: 'GET',
        params: query,
        includePagination: true,
      }
    );
  }
}

const evaluationOpportunityRequestsApi = new EvaluationOpportunityRequestsApi();
export default evaluationOpportunityRequestsApi;
